import React from "react";
import { NavigationConfigType, NavigationV2 } from "best-common-react";
import { useUser } from "../contexts/UserContext.tsx";
import { RouteConstants } from "../constants/route.ts";
import BullseyeLogo from "../assets/bullseye-logo.png";

const ENV = import.meta.env.VITE_ENV;

const Navigation: React.FC = () => {
  const { userDetails, roles, logout } = useUser();

  const config: NavigationConfigType = {
    env: ENV === "npd" ? "dev" : ENV,
    builds: [],
    title: "Bullseye",
    startLogo: {
      logo: "https://www.mlbstatic.com/team-logos/league-on-dark/1.svg",
      visible: true
    },
    endLogo: {
      logo: BullseyeLogo,
      visible: true
    },
    displayEnvIndicator: true,
    loggedIn: true,
    username: userDetails ? userDetails.fullName : "",
    tabletSupport: false,
    usernameDropdownLinks: [
      {
        name: "Sign Out",
        onClick: logout
      }
    ],
    navigationLinks: [
      {
        name: "Marketing Campaigns",
        quickLink: false,
        displayName: true,
        visible: roles?.includes("ROLE_MARKETING_QUERY_BUILD"),
        subLinks: [
          {
            name: "Create Marketing Campaign",
            icon: "fa-plus-circle",
            iconCategory: "fas",
            to: RouteConstants.MARKETING_CAMPAIGN.CREATE,
            quickLink: true,
            visible: true
          },
          {
            name: "Browse Marketing Campaigns",
            icon: "fa-folder-open",
            iconCategory: "far",
            to: RouteConstants.MARKETING_CAMPAIGN.BROWSE,
            quickLink: true,
            visible: true
          }
        ]
      },
      {
        name: "Email List Uploads",
        quickLink: false,
        displayName: true,
        visible: roles?.includes("ROLE_EMAIL_LIST_LOAD"),
        subLinks: [
          {
            name: "Upload Email List",
            icon: "fa-upload",
            iconCategory: "fas",
            to: RouteConstants.EMAIL_LISTS.UPLOAD,
            quickLink: true,
            visible: true
          },
          {
            name: "Browse Uploaded Lists",
            icon: "fa-folder-open",
            iconCategory: "far",
            to: RouteConstants.EMAIL_LISTS.BROWSE,
            quickLink: true,
            visible: true
          }
        ]
      }
    ]
  };

  return <NavigationV2 config={config} />;
};

export default Navigation;
